module.exports = __webpack_public_path__ + "static/media/ic_mobile.23b78422.svg";